import React from "react";

function Icon() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="321.742"
      height="885.823"
      fillRule="nonzero"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit="10"
      clipRule="evenodd"
      version="1.1"
      viewBox="0 0 321.742 885.823"
      xmlSpace="preserve"
      className='clickable'
    >
      <g
        fill="rgba(0,0,0,0)"
        className='object-glow'
        stroke="#ff5c97"
        strokeLinecap="round"
        strokeLinejoin="round"
        transform="translate(-1242.623 -726.083)"
      >
        <path
          strokeWidth="5"
          d="M1344 731.5c-6.53 2.333-14.93 9.1-25.2 20.3-5.13 5.6-10.27 11.2-15.4 16.8h4.2c-.23.933-.47 1.867-.7 2.8-.47 1.867-1.87 3.967-4.2 6.3-2.33 2.333-4.2 5.6-5.6 9.8-1.4 4.2-3.73 7.933-7 11.2-1.63 1.633-3.27 3.267-4.9 4.9.47.233.93.467 1.4.7.93.467 1.87 0 2.8-1.4.47-.7.93-1.4 1.4-2.1.23.467.47.933.7 1.4.47.933-.47 2.8-2.8 5.6s-4.43 8.633-6.3 17.5-4.9 16.1-9.1 21.7c-4.2 5.6-6.07 10.033-5.6 13.3.47 3.267 2.57 5.6 6.3 7 3.73 1.4 5.83 3.5 6.3 6.3.47 2.8-3.03 5.133-10.5 7-7.47 1.867-12.83 7.233-16.1 16.1-3.27 8.867-5.6 19.133-7 30.8-1.4 11.667-1.87 21.233-1.4 28.7.47 7.467 2.57 16.567 6.3 27.3s8.87 21.7 15.4 32.9c6.53 11.2 7 24.27 1.4 39.2-5.6 14.93-8.87 29.4-9.8 43.4-.93 14-1.17 29.17-.7 45.5s2.33 30.33 5.6 42c3.27 11.67 9.57 26.37 18.9 44.1 9.33 17.73 19.83 35 31.5 51.8 11.67 16.8 21 33.37 28 49.7 7 16.33 10.97 30.8 11.9 43.4.93 12.6 2.33 23.33 4.2 32.2 1.87 8.87-.47 16.1-7 21.7-6.53 5.6-10.03 9.8-10.5 12.6-.47 2.8 0 7 1.4 12.6s3.73 10.73 7 15.4 5.13 14 5.6 28c.47 14 1.63 24.27 3.5 30.8 1.87 6.53 5.13 13.3 9.8 20.3 4.67 7 8.4 10.5 11.2 10.5 2.8 0 6.3-2.33 10.5-7s6.07-12.13 5.6-22.4c-.47-10.27 1.4-17.03 5.6-20.3 2.1-1.63 4.2-3.27 6.3-4.9 1.63 4.43 3.27 8.87 4.9 13.3 3.27 8.87 4.43 14.93 3.5 18.2-.93 3.27-.93 8.4 0 15.4s.47 14.23-1.4 21.7c-1.87 7.47-2.57 13.3-2.1 17.5.47 4.2 3.27 8.17 8.4 11.9 5.13 3.73 12.83 5.83 23.1 6.3 10.27.47 17.73-.7 22.4-3.5 4.67-2.8 7-7 7-12.6s-1.63-12.83-4.9-21.7c-3.27-8.87-4.9-17.03-4.9-24.5 0-7.47-1.63-19.37-4.9-35.7-3.27-16.33-5.83-26.6-7.7-30.8-1.87-4.2-3.03-10.5-3.5-18.9-.47-8.4 2.57-16.8 9.1-25.2 6.53-8.4 20.07-19.83 40.6-34.3 20.53-14.47 35.7-26.6 45.5-36.4 9.8-9.8 15.63-17.03 17.5-21.7 1.87-4.67 2.57-15.4 2.1-32.2-.47-16.8-2.8-34.07-7-51.8-4.2-17.73-9.1-34.53-14.7-50.4-5.6-15.87-7.47-27.07-5.6-33.6 1.87-6.53 2.57-12.83 2.1-18.9-.47-6.07-3.03-13.77-7.7-23.1-4.67-9.33-7.23-28.47-7.7-57.4-.47-28.93-3.03-52.5-7.7-70.7-4.67-18.2-7-28.467-7-30.8 0-2.333 2.1-5.367 6.3-9.1 4.2-3.733 6.3-6.3 6.3-7.7 0-1.4-3.5-7.7-10.5-18.9s-14.7-22.167-23.1-32.9c-8.4-10.733-17.27-20.3-26.6-28.7-9.33-8.4-15.4-16.8-18.2-25.2-2.8-8.4-4.43-15.167-4.9-20.3-.47-5.133-1.63-9.567-3.5-13.3-1.87-3.733-3.5-11.433-4.9-23.1-1.4-11.667-4.67-22.167-9.8-31.5-5.13-9.333-9.1-15.4-11.9-18.2-2.8-2.8-7.93-6.3-15.4-10.5-7.47-4.2-15.4-6.533-23.8-7-8.4-.467-15.87.467-22.4 2.8zm88.2 552.3c.93.47 1.87.93 2.8 1.4 1.87.93 3.97 4.43 6.3 10.5 2.33 6.07 6.77 13.77 13.3 23.1 6.53 9.33 9.8 15.17 9.8 17.5s-4.67 7.93-14 16.8c-9.33 8.87-14.93 13.07-16.8 12.6-1.87-.47-3.27-3.5-4.2-9.1-.93-5.6-.7-12.83.7-21.7s2.1-19.6 2.1-32.2v-18.9z"
          opacity="1"
        ></path>
        <path
          strokeWidth="5"
          d="M1306.84 943.728c-2.58 3.99-8.47 7.6-11.96 10.997-9.14 8.9-18.37 20.8-22.68 33.1-3.85 11.008-2.54 25.875 12.71 20.875 5.63-1.84 9.7-6.23 15-8.2"
          opacity="1"
        ></path>
        <path
          strokeWidth="1"
          d="M1280.59 995.018c35.71.048 49.41 14.982 71.41.097 25.51-17.261 22-58.115 13-99.115v0c-1.51-13.831-3.04-37.545-12.39-48.717-5.02-5.997-4.21-2.953-10.76-8.695-3.09-2.706-1.86-7.859-5.98-9.718-3.92-1.77-10.04.763-9.34 5.392-5.26-4.024-8.14-.837-8.5 5.086-7.92-3.073-9.22 3.251-7.58 9.796-1.15-.668-.45-2.144-2.31-1.336-11.14 5.192 13.54 30.655 21.85 34.213"
          opacity="1"
        ></path>
        <path
          strokeWidth="5"
          d="M1499 975c2 14 3.25 40 5 65s-.16 27.23 1 37c1.58 13.31 6.86 23.65 2 21-22-12-73.55-7.97-93-8-61.43-.1-124 3-124 3"
          opacity="1"
        ></path>
        <path
          strokeWidth="5"
          d="M1398 1169s14.25 13.75 22 21 4.25 8.25 9 8 15-9 15-9"
          opacity="1"
        ></path>
        <path
          strokeWidth="5"
          d="M1427 1199s3 17.25 4 38 1 34 1 47"
          opacity="1"
        ></path>
        <path
          strokeWidth="5"
          d="M1508 1100s1 13.25 1 22-3.5 5.5-1 13 5 5.75 11 17 13 28 13 28"
          opacity="1"
        ></path>
        <path
          strokeWidth="5"
          d="M1462 899s9.48 7.971 17 17c5 6 7 5.5 12 20s8 41 8 41 6-2 9-6"
          opacity="1"
        ></path>
        <path
          strokeWidth="1"
          d="M1310.98 947.445c-1.99-1.597-1.98-5.445 1.52-14.514 2.23-5.769 6.91-18.314 9.5-23.931 4.01-8.68 6.71-20.14 10-29"
          opacity="1"
        ></path>
        <path
          strokeWidth="1"
          d="M1313.34 926.378c-10.56 0-28.86 8.451-37.08 14.612"
          opacity="1"
        ></path>
        <path strokeWidth="1" d="M1433.36 1367.76h-.36" opacity="1"></path>
        <path
          strokeWidth="5"
          d="M1432 1366c0 12.06 4.03 25.22 5.02 37.1 1.45 17.44.13 38.1 8.15 54.13"
          opacity="1"
        ></path>
        <path
          strokeWidth="5"
          d="M1358 1419s3.75 10.75 12 26 22 35 22 35-1.5 4.75 0 7 1 4 6 2c5.94-2.38 18.27-.84 28-4 11.47-3.73 20-12 20-12"
          opacity="1"
        ></path>
        <path
          strokeWidth="5"
          d="M1399.27 1491.03c-.13.36 6.33 10.7 6.56 12.84"
          opacity="1"
        ></path>
        <path
          strokeWidth="1"
          d="M1356.24 1442.89c-.51 1.36.57 3.52.72 4.93.63 6.01 1.97 12.49 1.85 18.54-.38 19.55 1.18 40.59 6.18 59.57 1.63 6.15 3.85 12.5 7.28 17.87.96 1.49 2.53 2.41 3.45 3.85 1.01 1.58 4.08 4.42 5.83 5.07.75.29 2.92 1.65 2.81 1.57"
          opacity="1"
        ></path>
        <path
          strokeWidth="1"
          d="M1413.61 1590.29c.2-.62.66.65.88.97.79 1.09 2.22 1.59 3.38 2.15 3.55 1.71 8.63 4.33 12.65 4.39 10.44.15 22.33-1.2 31.26-6.93 1.21-.77 7.97-8.08 7.08-8.94"
          opacity="1"
        ></path>
      </g>
    </svg>
  );
}

export default Icon;